module.exports = __webpack_public_path__ + "static/img/c_znzz82.74cfaf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_znzz82.png
// module id = lzzS
// module chunks = 73